const YOU_TRANSLATIONS = {
  de: 'du',
  en: 'you',
  es: 'tú',
  fr: 'vous',
  it: 'tu',
  ja: 'あなた',
  ko: '당신',
  pt: 'você',
  ru: 'вы',
  zh: '你',
  zh_tw: '你',
  ar: 'أنت',
  nl: 'jij',
  cs: 'ty',
  fil: 'ikaw',
  pl: 'ty',
  hu: 'te',
  ro: 'tu',
  no: 'deg',
  da: 'dig',
  sv: 'dig',
  fi: 'sinä',
  th: 'คุณ',
  vi: 'bạn',
  id: 'kamu',
  ms: 'kamu',
  'pt-br': 'você',
  tr: 'sen',
} as const

export const replaceCharIntroductionPlaceHolders = (
  introduction: string,
  charNickname: string,
  language: string = 'en'
): string => {
  return introduction
    .replaceAll('{{char}}', charNickname)
    .replaceAll(
      '{{user}}',
      YOU_TRANSLATIONS[language as keyof typeof YOU_TRANSLATIONS] || 'you'
    )
}

/** Matches the app home card: replace placeholders, then render source as text. */
export const toHomeCharacterPlainTextPreview = (
  introduction: string | null | undefined,
  charNickname: string,
  language: string = 'en'
): string => {
  return replaceCharIntroductionPlaceHolders(
    introduction ?? '',
    charNickname,
    language
  ).trim()
}
